// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/studioagent/v1/service.proto (package creativefabrica.studioagent.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Surface, SurfaceJson } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import { file_creativefabrica_common_v1_surface_v1_types } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import type { PaginationRequest, PaginationRequestJson, PaginationResponse, PaginationResponseJson } from "@repo/rpc-types-creativefabrica-common-v1";
import { file_creativefabrica_common_v1_types } from "@repo/rpc-types-creativefabrica-common-v1";
import type { Feedback, FeedbackJson, FeedbackRating, FeedbackRatingJson } from "../../feedback/v1/types_pb";
import { file_creativefabrica_feedback_v1_types } from "../../feedback/v1/types_pb";
import type { MediaType, MediaTypeJson } from "@repo/rpc-types-creativefabrica-modality-v1";
import { file_creativefabrica_modality_v1_types } from "@repo/rpc-types-creativefabrica-modality-v1";
import type { CatalogModel, CatalogModelJson } from "@repo/rpc-types-creativefabrica-preset-v1/ai_provider";
import { file_creativefabrica_preset_v1_ai_provider } from "@repo/rpc-types-creativefabrica-preset-v1/ai_provider";
import type { FieldValue, FieldValueJson } from "@repo/rpc-types-creativefabrica-preset-v1";
import { file_creativefabrica_preset_v1_types } from "@repo/rpc-types-creativefabrica-preset-v1";
import type { Agent, AgentJson, CharacterMediaType, CharacterMediaTypeJson, Conversation, ConversationGeneration, ConversationGenerationJson, ConversationJson, InputRef, InputRefJson, Message as Message$1, MessageJson, OutputRef, OutputRefJson, SendMessageStatus, SendMessageStatusJson } from "./types_pb";
import { file_creativefabrica_studioagent_v1_types } from "./types_pb";
import { file_google_api_annotations } from "@repo/rpc-types-google-api/annotations";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/studioagent/v1/service.proto.
 */
export const file_creativefabrica_studioagent_v1_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_creativefabrica_common_v1_surface_v1_types, file_creativefabrica_common_v1_types, file_creativefabrica_feedback_v1_types, file_creativefabrica_modality_v1_types, file_creativefabrica_preset_v1_ai_provider, file_creativefabrica_preset_v1_types, file_creativefabrica_studioagent_v1_types, file_google_api_annotations, file_google_protobuf_timestamp]);

/**
 * @generated from message creativefabrica.studioagent.v1.ListAgentsRequest
 */
export type ListAgentsRequest = Message<"creativefabrica.studioagent.v1.ListAgentsRequest"> & {
  /**
   * Deprecated string filter retained for wire compatibility. New callers use
   * surface_filter. Omitted returns all agents.
   *
   * @generated from field: optional string surface = 1 [deprecated = true];
   * @deprecated
   */
  surface?: string | undefined;

  /**
   * Filters agents to those supporting the selected product surface.
   * SURFACE_UNSPECIFIED returns all agents.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface_filter = 2;
   */
  surfaceFilter: Surface;
};

/**
 * @generated from message creativefabrica.studioagent.v1.ListAgentsRequest
 */
export type ListAgentsRequestJson = {
  /**
   * Deprecated string filter retained for wire compatibility. New callers use
   * surface_filter. Omitted returns all agents.
   *
   * @generated from field: optional string surface = 1 [deprecated = true];
   * @deprecated
   */
  surface?: string;

  /**
   * Filters agents to those supporting the selected product surface.
   * SURFACE_UNSPECIFIED returns all agents.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface_filter = 2;
   */
  surfaceFilter?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ListAgentsRequest.
 * Use `create(ListAgentsRequestSchema)` to create a new message.
 */
export const ListAgentsRequestSchema: GenMessage<ListAgentsRequest, {jsonType: ListAgentsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 0);

/**
 * @generated from message creativefabrica.studioagent.v1.ListAgentsResponse
 */
export type ListAgentsResponse = Message<"creativefabrica.studioagent.v1.ListAgentsResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.Agent agents = 1;
   */
  agents: Agent[];
};

/**
 * @generated from message creativefabrica.studioagent.v1.ListAgentsResponse
 */
export type ListAgentsResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.Agent agents = 1;
   */
  agents?: AgentJson[];
};

/**
 * Describes the message creativefabrica.studioagent.v1.ListAgentsResponse.
 * Use `create(ListAgentsResponseSchema)` to create a new message.
 */
export const ListAgentsResponseSchema: GenMessage<ListAgentsResponse, {jsonType: ListAgentsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 1);

/**
 * @generated from message creativefabrica.studioagent.v1.CreateConversationRequest
 */
export type CreateConversationRequest = Message<"creativefabrica.studioagent.v1.CreateConversationRequest"> & {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId: string;

  /**
   * character_id is required only for character-bound agents (e.g.
   * character_chat); agents without a character binding omit it. The per-agent
   * requirement is enforced by the service, not the wire contract.
   *
   * @generated from field: optional string character_id = 2;
   */
  characterId?: string | undefined;

  /**
   * Product surface pinned to this conversation. SURFACE_UNSPECIFIED defaults
   * to SURFACE_FREEMODE_AI; the selected agent must support the resolved
   * surface.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 3;
   */
  surface: Surface;
};

/**
 * @generated from message creativefabrica.studioagent.v1.CreateConversationRequest
 */
export type CreateConversationRequestJson = {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId?: string;

  /**
   * character_id is required only for character-bound agents (e.g.
   * character_chat); agents without a character binding omit it. The per-agent
   * requirement is enforced by the service, not the wire contract.
   *
   * @generated from field: optional string character_id = 2;
   */
  characterId?: string;

  /**
   * Product surface pinned to this conversation. SURFACE_UNSPECIFIED defaults
   * to SURFACE_FREEMODE_AI; the selected agent must support the resolved
   * surface.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 3;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.CreateConversationRequest.
 * Use `create(CreateConversationRequestSchema)` to create a new message.
 */
export const CreateConversationRequestSchema: GenMessage<CreateConversationRequest, {jsonType: CreateConversationRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 2);

/**
 * @generated from message creativefabrica.studioagent.v1.CreateConversationResponse
 */
export type CreateConversationResponse = Message<"creativefabrica.studioagent.v1.CreateConversationResponse"> & {
  /**
   * @generated from field: creativefabrica.studioagent.v1.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;
};

/**
 * @generated from message creativefabrica.studioagent.v1.CreateConversationResponse
 */
export type CreateConversationResponseJson = {
  /**
   * @generated from field: creativefabrica.studioagent.v1.Conversation conversation = 1;
   */
  conversation?: ConversationJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.CreateConversationResponse.
 * Use `create(CreateConversationResponseSchema)` to create a new message.
 */
export const CreateConversationResponseSchema: GenMessage<CreateConversationResponse, {jsonType: CreateConversationResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 3);

/**
 * @generated from message creativefabrica.studioagent.v1.ListConversationsRequest
 */
export type ListConversationsRequest = Message<"creativefabrica.studioagent.v1.ListConversationsRequest"> & {
  /**
   * Optional filters, combinable (AND semantics): character_id = "my chats
   * with this character"; agent_id = "my chats with this agent type";
   * surface = "my chats in this product experience".
   *
   * @generated from field: optional string character_id = 1;
   */
  characterId?: string | undefined;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * @generated from field: optional string agent_id = 3;
   */
  agentId?: string | undefined;

  /**
   * SURFACE_UNSPECIFIED does not filter by surface.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 4;
   */
  surface: Surface;
};

/**
 * @generated from message creativefabrica.studioagent.v1.ListConversationsRequest
 */
export type ListConversationsRequestJson = {
  /**
   * Optional filters, combinable (AND semantics): character_id = "my chats
   * with this character"; agent_id = "my chats with this agent type";
   * surface = "my chats in this product experience".
   *
   * @generated from field: optional string character_id = 1;
   */
  characterId?: string;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequestJson;

  /**
   * @generated from field: optional string agent_id = 3;
   */
  agentId?: string;

  /**
   * SURFACE_UNSPECIFIED does not filter by surface.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 4;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ListConversationsRequest.
 * Use `create(ListConversationsRequestSchema)` to create a new message.
 */
export const ListConversationsRequestSchema: GenMessage<ListConversationsRequest, {jsonType: ListConversationsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 4);

/**
 * @generated from message creativefabrica.studioagent.v1.ListConversationsResponse
 */
export type ListConversationsResponse = Message<"creativefabrica.studioagent.v1.ListConversationsResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.Conversation conversations = 1;
   */
  conversations: Conversation[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studioagent.v1.ListConversationsResponse
 */
export type ListConversationsResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.Conversation conversations = 1;
   */
  conversations?: ConversationJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ListConversationsResponse.
 * Use `create(ListConversationsResponseSchema)` to create a new message.
 */
export const ListConversationsResponseSchema: GenMessage<ListConversationsResponse, {jsonType: ListConversationsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 5);

/**
 * @generated from message creativefabrica.studioagent.v1.GetConversationRequest
 */
export type GetConversationRequest = Message<"creativefabrica.studioagent.v1.GetConversationRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * @generated from message creativefabrica.studioagent.v1.GetConversationRequest
 */
export type GetConversationRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.GetConversationRequest.
 * Use `create(GetConversationRequestSchema)` to create a new message.
 */
export const GetConversationRequestSchema: GenMessage<GetConversationRequest, {jsonType: GetConversationRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 6);

/**
 * @generated from message creativefabrica.studioagent.v1.GetConversationResponse
 */
export type GetConversationResponse = Message<"creativefabrica.studioagent.v1.GetConversationResponse"> & {
  /**
   * @generated from field: creativefabrica.studioagent.v1.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;

  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.Message messages = 2;
   */
  messages: Message$1[];

  /**
   * generations are the conversation's dispatched media generations
   * (generation-capable agents only; empty for pure chat).
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.ConversationGeneration generations = 3;
   */
  generations: ConversationGeneration[];

  /**
   * outputs is the conversation's token registry of completed generation
   * media ({{image_N}} / {{video_N}} / {{audio_N}}).
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.OutputRef outputs = 4;
   */
  outputs: OutputRef[];
};

/**
 * @generated from message creativefabrica.studioagent.v1.GetConversationResponse
 */
export type GetConversationResponseJson = {
  /**
   * @generated from field: creativefabrica.studioagent.v1.Conversation conversation = 1;
   */
  conversation?: ConversationJson;

  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.Message messages = 2;
   */
  messages?: MessageJson[];

  /**
   * generations are the conversation's dispatched media generations
   * (generation-capable agents only; empty for pure chat).
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.ConversationGeneration generations = 3;
   */
  generations?: ConversationGenerationJson[];

  /**
   * outputs is the conversation's token registry of completed generation
   * media ({{image_N}} / {{video_N}} / {{audio_N}}).
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.OutputRef outputs = 4;
   */
  outputs?: OutputRefJson[];
};

/**
 * Describes the message creativefabrica.studioagent.v1.GetConversationResponse.
 * Use `create(GetConversationResponseSchema)` to create a new message.
 */
export const GetConversationResponseSchema: GenMessage<GetConversationResponse, {jsonType: GetConversationResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 7);

/**
 * @generated from message creativefabrica.studioagent.v1.ListMessagesRequest
 */
export type ListMessagesRequest = Message<"creativefabrica.studioagent.v1.ListMessagesRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * pagination.after is the opaque cursor from a previous page (each page
   * returns the cursor for the page of OLDER messages before it); omit for the
   * most recent page. pagination.take caps the page size.
   *
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.studioagent.v1.ListMessagesRequest
 */
export type ListMessagesRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;

  /**
   * pagination.after is the opaque cursor from a previous page (each page
   * returns the cursor for the page of OLDER messages before it); omit for the
   * most recent page. pagination.take caps the page size.
   *
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ListMessagesRequest.
 * Use `create(ListMessagesRequestSchema)` to create a new message.
 */
export const ListMessagesRequestSchema: GenMessage<ListMessagesRequest, {jsonType: ListMessagesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 8);

/**
 * @generated from message creativefabrica.studioagent.v1.ListMessagesResponse
 */
export type ListMessagesResponse = Message<"creativefabrica.studioagent.v1.ListMessagesResponse"> & {
  /**
   * messages are newest-first within the page; reverse a page for display
   * order.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.Message messages = 1;
   */
  messages: Message$1[];

  /**
   * pagination.next loads the page of older messages; has_more is false at the
   * start of the conversation.
   *
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.studioagent.v1.ListMessagesResponse
 */
export type ListMessagesResponseJson = {
  /**
   * messages are newest-first within the page; reverse a page for display
   * order.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.Message messages = 1;
   */
  messages?: MessageJson[];

  /**
   * pagination.next loads the page of older messages; has_more is false at the
   * start of the conversation.
   *
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ListMessagesResponse.
 * Use `create(ListMessagesResponseSchema)` to create a new message.
 */
export const ListMessagesResponseSchema: GenMessage<ListMessagesResponse, {jsonType: ListMessagesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 9);

/**
 * @generated from message creativefabrica.studioagent.v1.RenameConversationRequest
 */
export type RenameConversationRequest = Message<"creativefabrica.studioagent.v1.RenameConversationRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;
};

/**
 * @generated from message creativefabrica.studioagent.v1.RenameConversationRequest
 */
export type RenameConversationRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.RenameConversationRequest.
 * Use `create(RenameConversationRequestSchema)` to create a new message.
 */
export const RenameConversationRequestSchema: GenMessage<RenameConversationRequest, {jsonType: RenameConversationRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 10);

/**
 * @generated from message creativefabrica.studioagent.v1.RenameConversationResponse
 */
export type RenameConversationResponse = Message<"creativefabrica.studioagent.v1.RenameConversationResponse"> & {
  /**
   * @generated from field: creativefabrica.studioagent.v1.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;
};

/**
 * @generated from message creativefabrica.studioagent.v1.RenameConversationResponse
 */
export type RenameConversationResponseJson = {
  /**
   * @generated from field: creativefabrica.studioagent.v1.Conversation conversation = 1;
   */
  conversation?: ConversationJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.RenameConversationResponse.
 * Use `create(RenameConversationResponseSchema)` to create a new message.
 */
export const RenameConversationResponseSchema: GenMessage<RenameConversationResponse, {jsonType: RenameConversationResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 11);

/**
 * @generated from message creativefabrica.studioagent.v1.DeleteConversationRequest
 */
export type DeleteConversationRequest = Message<"creativefabrica.studioagent.v1.DeleteConversationRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * @generated from message creativefabrica.studioagent.v1.DeleteConversationRequest
 */
export type DeleteConversationRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.DeleteConversationRequest.
 * Use `create(DeleteConversationRequestSchema)` to create a new message.
 */
export const DeleteConversationRequestSchema: GenMessage<DeleteConversationRequest, {jsonType: DeleteConversationRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 12);

/**
 * @generated from message creativefabrica.studioagent.v1.DeleteConversationResponse
 */
export type DeleteConversationResponse = Message<"creativefabrica.studioagent.v1.DeleteConversationResponse"> & {
};

/**
 * @generated from message creativefabrica.studioagent.v1.DeleteConversationResponse
 */
export type DeleteConversationResponseJson = {
};

/**
 * Describes the message creativefabrica.studioagent.v1.DeleteConversationResponse.
 * Use `create(DeleteConversationResponseSchema)` to create a new message.
 */
export const DeleteConversationResponseSchema: GenMessage<DeleteConversationResponse, {jsonType: DeleteConversationResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 13);

/**
 * @generated from message creativefabrica.studioagent.v1.EstimateTurnRequest
 */
export type EstimateTurnRequest = Message<"creativefabrica.studioagent.v1.EstimateTurnRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;
};

/**
 * @generated from message creativefabrica.studioagent.v1.EstimateTurnRequest
 */
export type EstimateTurnRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;

  /**
   * @generated from field: string text = 2;
   */
  text?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.EstimateTurnRequest.
 * Use `create(EstimateTurnRequestSchema)` to create a new message.
 */
export const EstimateTurnRequestSchema: GenMessage<EstimateTurnRequest, {jsonType: EstimateTurnRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 14);

/**
 * @generated from message creativefabrica.studioagent.v1.EstimateTurnResponse
 */
export type EstimateTurnResponse = Message<"creativefabrica.studioagent.v1.EstimateTurnResponse"> & {
  /**
   * estimated_coins is the flat per-turn price; 0 for agents whose chat turns
   * are free (generations are priced on the approval card instead).
   *
   * @generated from field: int64 estimated_coins = 1;
   */
  estimatedCoins: bigint;

  /**
   * @generated from field: int64 balance = 2;
   */
  balance: bigint;
};

/**
 * @generated from message creativefabrica.studioagent.v1.EstimateTurnResponse
 */
export type EstimateTurnResponseJson = {
  /**
   * estimated_coins is the flat per-turn price; 0 for agents whose chat turns
   * are free (generations are priced on the approval card instead).
   *
   * @generated from field: int64 estimated_coins = 1;
   */
  estimatedCoins?: string;

  /**
   * @generated from field: int64 balance = 2;
   */
  balance?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.EstimateTurnResponse.
 * Use `create(EstimateTurnResponseSchema)` to create a new message.
 */
export const EstimateTurnResponseSchema: GenMessage<EstimateTurnResponse, {jsonType: EstimateTurnResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 15);

/**
 * @generated from message creativefabrica.studioagent.v1.SendMessageRequest
 */
export type SendMessageRequest = Message<"creativefabrica.studioagent.v1.SendMessageRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;
};

/**
 * @generated from message creativefabrica.studioagent.v1.SendMessageRequest
 */
export type SendMessageRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;

  /**
   * @generated from field: string text = 2;
   */
  text?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.SendMessageRequest.
 * Use `create(SendMessageRequestSchema)` to create a new message.
 */
export const SendMessageRequestSchema: GenMessage<SendMessageRequest, {jsonType: SendMessageRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 16);

/**
 * @generated from message creativefabrica.studioagent.v1.SendMessageResponse
 */
export type SendMessageResponse = Message<"creativefabrica.studioagent.v1.SendMessageResponse"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.SendMessageStatus status = 2;
   */
  status: SendMessageStatus;
};

/**
 * @generated from message creativefabrica.studioagent.v1.SendMessageResponse
 */
export type SendMessageResponseJson = {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId?: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.SendMessageStatus status = 2;
   */
  status?: SendMessageStatusJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.SendMessageResponse.
 * Use `create(SendMessageResponseSchema)` to create a new message.
 */
export const SendMessageResponseSchema: GenMessage<SendMessageResponse, {jsonType: SendMessageResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 17);

/**
 * @generated from message creativefabrica.studioagent.v1.PrepareConversationUploadsRequest
 */
export type PrepareConversationUploadsRequest = Message<"creativefabrica.studioagent.v1.PrepareConversationUploadsRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.ConversationUploadFile files = 2;
   */
  files: ConversationUploadFile[];
};

/**
 * @generated from message creativefabrica.studioagent.v1.PrepareConversationUploadsRequest
 */
export type PrepareConversationUploadsRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;

  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.ConversationUploadFile files = 2;
   */
  files?: ConversationUploadFileJson[];
};

/**
 * Describes the message creativefabrica.studioagent.v1.PrepareConversationUploadsRequest.
 * Use `create(PrepareConversationUploadsRequestSchema)` to create a new message.
 */
export const PrepareConversationUploadsRequestSchema: GenMessage<PrepareConversationUploadsRequest, {jsonType: PrepareConversationUploadsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 18);

/**
 * ConversationUploadFile is client-declared metadata for one upload. The
 * service validates and later probe-checks the uploaded bytes.
 *
 * @generated from message creativefabrica.studioagent.v1.ConversationUploadFile
 */
export type ConversationUploadFile = Message<"creativefabrica.studioagent.v1.ConversationUploadFile"> & {
  /**
   * Caller-generated correlation id, echoed in the response.
   *
   * @generated from field: string client_file_id = 1;
   */
  clientFileId: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 3;
   */
  fileSize: bigint;

  /**
   * @generated from field: string mime_type = 4;
   */
  mimeType: string;
};

/**
 * ConversationUploadFile is client-declared metadata for one upload. The
 * service validates and later probe-checks the uploaded bytes.
 *
 * @generated from message creativefabrica.studioagent.v1.ConversationUploadFile
 */
export type ConversationUploadFileJson = {
  /**
   * Caller-generated correlation id, echoed in the response.
   *
   * @generated from field: string client_file_id = 1;
   */
  clientFileId?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;

  /**
   * @generated from field: int64 file_size = 3;
   */
  fileSize?: string;

  /**
   * @generated from field: string mime_type = 4;
   */
  mimeType?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ConversationUploadFile.
 * Use `create(ConversationUploadFileSchema)` to create a new message.
 */
export const ConversationUploadFileSchema: GenMessage<ConversationUploadFile, {jsonType: ConversationUploadFileJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 19);

/**
 * @generated from message creativefabrica.studioagent.v1.PrepareConversationUploadsResponse
 */
export type PrepareConversationUploadsResponse = Message<"creativefabrica.studioagent.v1.PrepareConversationUploadsResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.PreparedConversationUpload uploads = 1;
   */
  uploads: PreparedConversationUpload[];
};

/**
 * @generated from message creativefabrica.studioagent.v1.PrepareConversationUploadsResponse
 */
export type PrepareConversationUploadsResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.PreparedConversationUpload uploads = 1;
   */
  uploads?: PreparedConversationUploadJson[];
};

/**
 * Describes the message creativefabrica.studioagent.v1.PrepareConversationUploadsResponse.
 * Use `create(PrepareConversationUploadsResponseSchema)` to create a new message.
 */
export const PrepareConversationUploadsResponseSchema: GenMessage<PrepareConversationUploadsResponse, {jsonType: PrepareConversationUploadsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 20);

/**
 * @generated from message creativefabrica.studioagent.v1.RegisterExternalAssetRequest
 */
export type RegisterExternalAssetRequest = Message<"creativefabrica.studioagent.v1.RegisterExternalAssetRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * url is the object's CDN or S3 URL exactly as the producing product
   * exposes it (for example a video generator's video URL).
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * metadata is caller-defined provenance stored with the ref and returned
   * on InputRef.metadata. By convention tool_name names the producing product
   * (video_generator, video_editor, flow, …) and id its object id; other keys
   * are kept as given.
   *
   * @generated from field: map<string, string> metadata = 3;
   */
  metadata: { [key: string]: string };
};

/**
 * @generated from message creativefabrica.studioagent.v1.RegisterExternalAssetRequest
 */
export type RegisterExternalAssetRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;

  /**
   * url is the object's CDN or S3 URL exactly as the producing product
   * exposes it (for example a video generator's video URL).
   *
   * @generated from field: string url = 2;
   */
  url?: string;

  /**
   * metadata is caller-defined provenance stored with the ref and returned
   * on InputRef.metadata. By convention tool_name names the producing product
   * (video_generator, video_editor, flow, …) and id its object id; other keys
   * are kept as given.
   *
   * @generated from field: map<string, string> metadata = 3;
   */
  metadata?: { [key: string]: string };
};

/**
 * Describes the message creativefabrica.studioagent.v1.RegisterExternalAssetRequest.
 * Use `create(RegisterExternalAssetRequestSchema)` to create a new message.
 */
export const RegisterExternalAssetRequestSchema: GenMessage<RegisterExternalAssetRequest, {jsonType: RegisterExternalAssetRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 21);

/**
 * @generated from message creativefabrica.studioagent.v1.RegisterExternalAssetResponse
 */
export type RegisterExternalAssetResponse = Message<"creativefabrica.studioagent.v1.RegisterExternalAssetResponse"> & {
  /**
   * input_ref is the registered (or already registered) asset, READY with a
   * short-lived preview URL.
   *
   * @generated from field: creativefabrica.studioagent.v1.InputRef input_ref = 1;
   */
  inputRef?: InputRef | undefined;
};

/**
 * @generated from message creativefabrica.studioagent.v1.RegisterExternalAssetResponse
 */
export type RegisterExternalAssetResponseJson = {
  /**
   * input_ref is the registered (or already registered) asset, READY with a
   * short-lived preview URL.
   *
   * @generated from field: creativefabrica.studioagent.v1.InputRef input_ref = 1;
   */
  inputRef?: InputRefJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.RegisterExternalAssetResponse.
 * Use `create(RegisterExternalAssetResponseSchema)` to create a new message.
 */
export const RegisterExternalAssetResponseSchema: GenMessage<RegisterExternalAssetResponse, {jsonType: RegisterExternalAssetResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 22);

/**
 * @generated from message creativefabrica.studioagent.v1.ImportWebMediaRequest
 */
export type ImportWebMediaRequest = Message<"creativefabrica.studioagent.v1.ImportWebMediaRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * url is the http or https URL of an image or video file, at most 2048
   * characters.
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * Caller-generated correlation id (the client's tile id); a retry with the
   * same id returns the same ref.
   *
   * @generated from field: string client_file_id = 3;
   */
  clientFileId: string;
};

/**
 * @generated from message creativefabrica.studioagent.v1.ImportWebMediaRequest
 */
export type ImportWebMediaRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;

  /**
   * url is the http or https URL of an image or video file, at most 2048
   * characters.
   *
   * @generated from field: string url = 2;
   */
  url?: string;

  /**
   * Caller-generated correlation id (the client's tile id); a retry with the
   * same id returns the same ref.
   *
   * @generated from field: string client_file_id = 3;
   */
  clientFileId?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ImportWebMediaRequest.
 * Use `create(ImportWebMediaRequestSchema)` to create a new message.
 */
export const ImportWebMediaRequestSchema: GenMessage<ImportWebMediaRequest, {jsonType: ImportWebMediaRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 23);

/**
 * @generated from message creativefabrica.studioagent.v1.ImportWebMediaResponse
 */
export type ImportWebMediaResponse = Message<"creativefabrica.studioagent.v1.ImportWebMediaResponse"> & {
  /**
   * input_ref is the new (or already imported) ref: PENDING with
   * web_import.stage QUEUED, or its current state when it already existed.
   *
   * @generated from field: creativefabrica.studioagent.v1.InputRef input_ref = 1;
   */
  inputRef?: InputRef | undefined;
};

/**
 * @generated from message creativefabrica.studioagent.v1.ImportWebMediaResponse
 */
export type ImportWebMediaResponseJson = {
  /**
   * input_ref is the new (or already imported) ref: PENDING with
   * web_import.stage QUEUED, or its current state when it already existed.
   *
   * @generated from field: creativefabrica.studioagent.v1.InputRef input_ref = 1;
   */
  inputRef?: InputRefJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ImportWebMediaResponse.
 * Use `create(ImportWebMediaResponseSchema)` to create a new message.
 */
export const ImportWebMediaResponseSchema: GenMessage<ImportWebMediaResponse, {jsonType: ImportWebMediaResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 24);

/**
 * PreparedConversationUpload describes a presigned multipart/form-data POST.
 * Submit every form_fields entry plus the file bytes to upload_url before
 * expires_at.
 *
 * @generated from message creativefabrica.studioagent.v1.PreparedConversationUpload
 */
export type PreparedConversationUpload = Message<"creativefabrica.studioagent.v1.PreparedConversationUpload"> & {
  /**
   * @generated from field: string client_file_id = 1;
   */
  clientFileId: string;

  /**
   * ref is the reserved conversation asset token (for example {{upload_3}}).
   *
   * @generated from field: string ref = 2;
   */
  ref: string;

  /**
   * @generated from field: string upload_url = 3;
   */
  uploadUrl: string;

  /**
   * @generated from field: map<string, string> form_fields = 4;
   */
  formFields: { [key: string]: string };

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 5;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * PreparedConversationUpload describes a presigned multipart/form-data POST.
 * Submit every form_fields entry plus the file bytes to upload_url before
 * expires_at.
 *
 * @generated from message creativefabrica.studioagent.v1.PreparedConversationUpload
 */
export type PreparedConversationUploadJson = {
  /**
   * @generated from field: string client_file_id = 1;
   */
  clientFileId?: string;

  /**
   * ref is the reserved conversation asset token (for example {{upload_3}}).
   *
   * @generated from field: string ref = 2;
   */
  ref?: string;

  /**
   * @generated from field: string upload_url = 3;
   */
  uploadUrl?: string;

  /**
   * @generated from field: map<string, string> form_fields = 4;
   */
  formFields?: { [key: string]: string };

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 5;
   */
  expiresAt?: TimestampJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.PreparedConversationUpload.
 * Use `create(PreparedConversationUploadSchema)` to create a new message.
 */
export const PreparedConversationUploadSchema: GenMessage<PreparedConversationUpload, {jsonType: PreparedConversationUploadJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 25);

/**
 * @generated from message creativefabrica.studioagent.v1.ResolveMessageActionRequest
 */
export type ResolveMessageActionRequest = Message<"creativefabrica.studioagent.v1.ResolveMessageActionRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.ResolveMessageActionDecision decision = 3;
   */
  decision: ResolveMessageActionDecision;

  /**
   * voice_choices swap speakers on a speech card as part of an approval: each
   * replaces every use of a voice in the plan's options with another voice of
   * the plan's voice_catalog. The plan is re-validated and re-priced, the card
   * keeps the approved voices, and nothing else in the plan changes. Allowed
   * only with APPROVE on a card whose plan has a voice_catalog; an unknown
   * voice, a voice not on the card, or a repeated from_voice_id fails with
   * INVALID_ARGUMENT and leaves the card pending. Ignored when the card was
   * already approved (approval stays idempotent).
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.VoiceChoice voice_choices = 4;
   */
  voiceChoices: VoiceChoice[];

  /**
   * plan_choice is the model and options the user settled on while editing
   * the card. Optional: omitted, the frozen plan is approved exactly as shown,
   * as before this field existed. Set it only when the user changed something;
   * a choice equal to the card is accepted. Allowed only with APPROVE on a
   * card whose model_choices is non-empty. The server re-validates the choice
   * with the same checks as the original proposal, re-prices it itself (a
   * client quote is never sent or trusted), and dispatches the revised plan,
   * which the approved card then shows; a model outside model_choices or an
   * option the model rejects fails with INVALID_ARGUMENT naming the field and
   * leaves the card pending. Ignored when the card was already approved.
   * Applied before voice_choices when both are sent.
   *
   * @generated from field: creativefabrica.studioagent.v1.PlanChoice plan_choice = 5;
   */
  planChoice?: PlanChoice | undefined;
};

/**
 * @generated from message creativefabrica.studioagent.v1.ResolveMessageActionRequest
 */
export type ResolveMessageActionRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;

  /**
   * @generated from field: string message_id = 2;
   */
  messageId?: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.ResolveMessageActionDecision decision = 3;
   */
  decision?: ResolveMessageActionDecisionJson;

  /**
   * voice_choices swap speakers on a speech card as part of an approval: each
   * replaces every use of a voice in the plan's options with another voice of
   * the plan's voice_catalog. The plan is re-validated and re-priced, the card
   * keeps the approved voices, and nothing else in the plan changes. Allowed
   * only with APPROVE on a card whose plan has a voice_catalog; an unknown
   * voice, a voice not on the card, or a repeated from_voice_id fails with
   * INVALID_ARGUMENT and leaves the card pending. Ignored when the card was
   * already approved (approval stays idempotent).
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.VoiceChoice voice_choices = 4;
   */
  voiceChoices?: VoiceChoiceJson[];

  /**
   * plan_choice is the model and options the user settled on while editing
   * the card. Optional: omitted, the frozen plan is approved exactly as shown,
   * as before this field existed. Set it only when the user changed something;
   * a choice equal to the card is accepted. Allowed only with APPROVE on a
   * card whose model_choices is non-empty. The server re-validates the choice
   * with the same checks as the original proposal, re-prices it itself (a
   * client quote is never sent or trusted), and dispatches the revised plan,
   * which the approved card then shows; a model outside model_choices or an
   * option the model rejects fails with INVALID_ARGUMENT naming the field and
   * leaves the card pending. Ignored when the card was already approved.
   * Applied before voice_choices when both are sent.
   *
   * @generated from field: creativefabrica.studioagent.v1.PlanChoice plan_choice = 5;
   */
  planChoice?: PlanChoiceJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ResolveMessageActionRequest.
 * Use `create(ResolveMessageActionRequestSchema)` to create a new message.
 */
export const ResolveMessageActionRequestSchema: GenMessage<ResolveMessageActionRequest, {jsonType: ResolveMessageActionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 26);

/**
 * VoiceChoice replaces one speaker's voice on a speech card.
 *
 * @generated from message creativefabrica.studioagent.v1.VoiceChoice
 */
export type VoiceChoice = Message<"creativefabrica.studioagent.v1.VoiceChoice"> & {
  /**
   * from_voice_id is a voice id currently in the card's plan options.
   *
   * @generated from field: string from_voice_id = 1;
   */
  fromVoiceId: string;

  /**
   * to_voice_id is the replacement, a voice_id from the plan's voice_catalog.
   *
   * @generated from field: string to_voice_id = 2;
   */
  toVoiceId: string;
};

/**
 * VoiceChoice replaces one speaker's voice on a speech card.
 *
 * @generated from message creativefabrica.studioagent.v1.VoiceChoice
 */
export type VoiceChoiceJson = {
  /**
   * from_voice_id is a voice id currently in the card's plan options.
   *
   * @generated from field: string from_voice_id = 1;
   */
  fromVoiceId?: string;

  /**
   * to_voice_id is the replacement, a voice_id from the plan's voice_catalog.
   *
   * @generated from field: string to_voice_id = 2;
   */
  toVoiceId?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.VoiceChoice.
 * Use `create(VoiceChoiceSchema)` to create a new message.
 */
export const VoiceChoiceSchema: GenMessage<VoiceChoice, {jsonType: VoiceChoiceJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 27);

/**
 * PlanChoice is the user's edit of a card: the model to generate with and the
 * complete option set for it. Inputs and prompt stay as they are on the card.
 *
 * @generated from message creativefabrica.studioagent.v1.PlanChoice
 */
export type PlanChoice = Message<"creativefabrica.studioagent.v1.PlanChoice"> & {
  /**
   * model is the chosen model id: any MediaGenerationApproval.model_choices
   * entry, the card's current model included.
   *
   * @generated from field: string model = 1;
   */
  model: string;

  /**
   * options is the complete option set for that model as the user sees it,
   * keyed by the option names of its CatalogModel.capabilities.input_options.
   * It replaces the plan's options rather than patching them; an omitted
   * option takes the model's default, as it does for a fresh proposal.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> options = 2;
   */
  options: { [key: string]: FieldValue };
};

/**
 * PlanChoice is the user's edit of a card: the model to generate with and the
 * complete option set for it. Inputs and prompt stay as they are on the card.
 *
 * @generated from message creativefabrica.studioagent.v1.PlanChoice
 */
export type PlanChoiceJson = {
  /**
   * model is the chosen model id: any MediaGenerationApproval.model_choices
   * entry, the card's current model included.
   *
   * @generated from field: string model = 1;
   */
  model?: string;

  /**
   * options is the complete option set for that model as the user sees it,
   * keyed by the option names of its CatalogModel.capabilities.input_options.
   * It replaces the plan's options rather than patching them; an omitted
   * option takes the model's default, as it does for a fresh proposal.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> options = 2;
   */
  options?: { [key: string]: FieldValueJson };
};

/**
 * Describes the message creativefabrica.studioagent.v1.PlanChoice.
 * Use `create(PlanChoiceSchema)` to create a new message.
 */
export const PlanChoiceSchema: GenMessage<PlanChoice, {jsonType: PlanChoiceJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 28);

/**
 * @generated from message creativefabrica.studioagent.v1.ResolveMessageActionResponse
 */
export type ResolveMessageActionResponse = Message<"creativefabrica.studioagent.v1.ResolveMessageActionResponse"> & {
  /**
   * action_message is the original assistant card with its updated action.
   *
   * @generated from field: creativefabrica.studioagent.v1.Message action_message = 1;
   */
  actionMessage?: Message$1 | undefined;

  /**
   * created_message is the separate MESSAGE_TYPE_MEDIA message created by an
   * approval. It is absent for rejection.
   *
   * @generated from field: creativefabrica.studioagent.v1.Message created_message = 2;
   */
  createdMessage?: Message$1 | undefined;
};

/**
 * @generated from message creativefabrica.studioagent.v1.ResolveMessageActionResponse
 */
export type ResolveMessageActionResponseJson = {
  /**
   * action_message is the original assistant card with its updated action.
   *
   * @generated from field: creativefabrica.studioagent.v1.Message action_message = 1;
   */
  actionMessage?: MessageJson;

  /**
   * created_message is the separate MESSAGE_TYPE_MEDIA message created by an
   * approval. It is absent for rejection.
   *
   * @generated from field: creativefabrica.studioagent.v1.Message created_message = 2;
   */
  createdMessage?: MessageJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ResolveMessageActionResponse.
 * Use `create(ResolveMessageActionResponseSchema)` to create a new message.
 */
export const ResolveMessageActionResponseSchema: GenMessage<ResolveMessageActionResponse, {jsonType: ResolveMessageActionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 29);

/**
 * @generated from message creativefabrica.studioagent.v1.GenerateCharacterMediaRequest
 */
export type GenerateCharacterMediaRequest = Message<"creativefabrica.studioagent.v1.GenerateCharacterMediaRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * media_type selects the model: IMAGE (Seedream) or VIDEO (Seedance).
   *
   * @generated from field: creativefabrica.studioagent.v1.CharacterMediaType media_type = 2;
   */
  mediaType: CharacterMediaType;

  /**
   * prompt is the user's generation intent; the service enriches it with the
   * character's current roleplay mood before dispatch.
   *
   * @generated from field: string prompt = 3;
   */
  prompt: string;

  /**
   * options are the model's genai input options (e.g. aspect_ratio, resolution,
   * duration_seconds). Deprecated character overrides are ignored; approval
   * always dispatches the server's fixed character settings.
   *
   * @generated from field: map<string, string> options = 4 [deprecated = true];
   * @deprecated
   */
  options: { [key: string]: string };
};

/**
 * @generated from message creativefabrica.studioagent.v1.GenerateCharacterMediaRequest
 */
export type GenerateCharacterMediaRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;

  /**
   * media_type selects the model: IMAGE (Seedream) or VIDEO (Seedance).
   *
   * @generated from field: creativefabrica.studioagent.v1.CharacterMediaType media_type = 2;
   */
  mediaType?: CharacterMediaTypeJson;

  /**
   * prompt is the user's generation intent; the service enriches it with the
   * character's current roleplay mood before dispatch.
   *
   * @generated from field: string prompt = 3;
   */
  prompt?: string;

  /**
   * options are the model's genai input options (e.g. aspect_ratio, resolution,
   * duration_seconds). Deprecated character overrides are ignored; approval
   * always dispatches the server's fixed character settings.
   *
   * @generated from field: map<string, string> options = 4 [deprecated = true];
   * @deprecated
   */
  options?: { [key: string]: string };
};

/**
 * Describes the message creativefabrica.studioagent.v1.GenerateCharacterMediaRequest.
 * Use `create(GenerateCharacterMediaRequestSchema)` to create a new message.
 */
export const GenerateCharacterMediaRequestSchema: GenMessage<GenerateCharacterMediaRequest, {jsonType: GenerateCharacterMediaRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 30);

/**
 * @generated from message creativefabrica.studioagent.v1.GenerateCharacterMediaResponse
 */
export type GenerateCharacterMediaResponse = Message<"creativefabrica.studioagent.v1.GenerateCharacterMediaResponse"> & {
  /**
   * message_id is the completed assistant action awaiting approval.
   *
   * @generated from field: string message_id = 1;
   */
  messageId: string;
};

/**
 * @generated from message creativefabrica.studioagent.v1.GenerateCharacterMediaResponse
 */
export type GenerateCharacterMediaResponseJson = {
  /**
   * message_id is the completed assistant action awaiting approval.
   *
   * @generated from field: string message_id = 1;
   */
  messageId?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.GenerateCharacterMediaResponse.
 * Use `create(GenerateCharacterMediaResponseSchema)` to create a new message.
 */
export const GenerateCharacterMediaResponseSchema: GenMessage<GenerateCharacterMediaResponse, {jsonType: GenerateCharacterMediaResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 31);

/**
 * @generated from message creativefabrica.studioagent.v1.ListConversationRefsRequest
 */
export type ListConversationRefsRequest = Message<"creativefabrica.studioagent.v1.ListConversationRefsRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * media_type filters refs by output media type (image / video / audio);
   * omitted returns all.
   *
   * @generated from field: optional creativefabrica.modality.v1.MediaType media_type = 2;
   */
  mediaType?: MediaType | undefined;
};

/**
 * @generated from message creativefabrica.studioagent.v1.ListConversationRefsRequest
 */
export type ListConversationRefsRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;

  /**
   * media_type filters refs by output media type (image / video / audio);
   * omitted returns all.
   *
   * @generated from field: optional creativefabrica.modality.v1.MediaType media_type = 2;
   */
  mediaType?: MediaTypeJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ListConversationRefsRequest.
 * Use `create(ListConversationRefsRequestSchema)` to create a new message.
 */
export const ListConversationRefsRequestSchema: GenMessage<ListConversationRefsRequest, {jsonType: ListConversationRefsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 32);

/**
 * @generated from message creativefabrica.studioagent.v1.ListConversationRefsResponse
 */
export type ListConversationRefsResponse = Message<"creativefabrica.studioagent.v1.ListConversationRefsResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.OutputRef refs = 1;
   */
  refs: OutputRef[];

  /**
   * input_refs is the product-safe registry used for uploads and generated
   * output reuse. Preview URLs are short-lived.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.InputRef input_refs = 2;
   */
  inputRefs: InputRef[];
};

/**
 * @generated from message creativefabrica.studioagent.v1.ListConversationRefsResponse
 */
export type ListConversationRefsResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.OutputRef refs = 1;
   */
  refs?: OutputRefJson[];

  /**
   * input_refs is the product-safe registry used for uploads and generated
   * output reuse. Preview URLs are short-lived.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.InputRef input_refs = 2;
   */
  inputRefs?: InputRefJson[];
};

/**
 * Describes the message creativefabrica.studioagent.v1.ListConversationRefsResponse.
 * Use `create(ListConversationRefsResponseSchema)` to create a new message.
 */
export const ListConversationRefsResponseSchema: GenMessage<ListConversationRefsResponse, {jsonType: ListConversationRefsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 33);

/**
 * @generated from message creativefabrica.studioagent.v1.BatchGetInputRefsRequest
 */
export type BatchGetInputRefsRequest = Message<"creativefabrica.studioagent.v1.BatchGetInputRefsRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * refs are InputRef.ref tokens (for example {{upload_3}}), 1 to 10.
   *
   * @generated from field: repeated string refs = 2;
   */
  refs: string[];
};

/**
 * @generated from message creativefabrica.studioagent.v1.BatchGetInputRefsRequest
 */
export type BatchGetInputRefsRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;

  /**
   * refs are InputRef.ref tokens (for example {{upload_3}}), 1 to 10.
   *
   * @generated from field: repeated string refs = 2;
   */
  refs?: string[];
};

/**
 * Describes the message creativefabrica.studioagent.v1.BatchGetInputRefsRequest.
 * Use `create(BatchGetInputRefsRequestSchema)` to create a new message.
 */
export const BatchGetInputRefsRequestSchema: GenMessage<BatchGetInputRefsRequest, {jsonType: BatchGetInputRefsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 34);

/**
 * @generated from message creativefabrica.studioagent.v1.BatchGetInputRefsResponse
 */
export type BatchGetInputRefsResponse = Message<"creativefabrica.studioagent.v1.BatchGetInputRefsResponse"> & {
  /**
   * input_refs are the known refs, in request order. Preview URLs are
   * short-lived.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.InputRef input_refs = 1;
   */
  inputRefs: InputRef[];
};

/**
 * @generated from message creativefabrica.studioagent.v1.BatchGetInputRefsResponse
 */
export type BatchGetInputRefsResponseJson = {
  /**
   * input_refs are the known refs, in request order. Preview URLs are
   * short-lived.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.InputRef input_refs = 1;
   */
  inputRefs?: InputRefJson[];
};

/**
 * Describes the message creativefabrica.studioagent.v1.BatchGetInputRefsResponse.
 * Use `create(BatchGetInputRefsResponseSchema)` to create a new message.
 */
export const BatchGetInputRefsResponseSchema: GenMessage<BatchGetInputRefsResponse, {jsonType: BatchGetInputRefsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 35);

/**
 * @generated from message creativefabrica.studioagent.v1.ListGenerationModelsRequest
 */
export type ListGenerationModelsRequest = Message<"creativefabrica.studioagent.v1.ListGenerationModelsRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * models limits the response to these model ids, in any order — typically
   * a card's model_choices. An id the conversation does not offer is left out
   * rather than failing the call. Empty returns every model the conversation
   * offers.
   *
   * @generated from field: repeated string models = 2;
   */
  models: string[];
};

/**
 * @generated from message creativefabrica.studioagent.v1.ListGenerationModelsRequest
 */
export type ListGenerationModelsRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;

  /**
   * models limits the response to these model ids, in any order — typically
   * a card's model_choices. An id the conversation does not offer is left out
   * rather than failing the call. Empty returns every model the conversation
   * offers.
   *
   * @generated from field: repeated string models = 2;
   */
  models?: string[];
};

/**
 * Describes the message creativefabrica.studioagent.v1.ListGenerationModelsRequest.
 * Use `create(ListGenerationModelsRequestSchema)` to create a new message.
 */
export const ListGenerationModelsRequestSchema: GenMessage<ListGenerationModelsRequest, {jsonType: ListGenerationModelsRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 36);

/**
 * @generated from message creativefabrica.studioagent.v1.ListGenerationModelsResponse
 */
export type ListGenerationModelsResponse = Message<"creativefabrica.studioagent.v1.ListGenerationModelsResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.GenerationModelEntry models = 1;
   */
  models: GenerationModelEntry[];
};

/**
 * @generated from message creativefabrica.studioagent.v1.ListGenerationModelsResponse
 */
export type ListGenerationModelsResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.GenerationModelEntry models = 1;
   */
  models?: GenerationModelEntryJson[];
};

/**
 * Describes the message creativefabrica.studioagent.v1.ListGenerationModelsResponse.
 * Use `create(ListGenerationModelsResponseSchema)` to create a new message.
 */
export const ListGenerationModelsResponseSchema: GenMessage<ListGenerationModelsResponse, {jsonType: ListGenerationModelsResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 37);

/**
 * @generated from message creativefabrica.studioagent.v1.SetGenerationFeedbackRequest
 */
export type SetGenerationFeedbackRequest = Message<"creativefabrica.studioagent.v1.SetGenerationFeedbackRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * generation_id is the genai generation id — the
   * creativefabrica.modality.v1.Generation.generation_id a MEDIA message
   * carries in Message.generation.
   *
   * @generated from field: string generation_id = 2;
   */
  generationId: string;

  /**
   * rating, when present, replaces the rating; FEEDBACK_RATING_UNSPECIFIED
   * clears it. Absent leaves the rating unchanged.
   *
   * @generated from field: optional creativefabrica.feedback.v1.FeedbackRating rating = 3;
   */
  rating?: FeedbackRating | undefined;

  /**
   * comment, when present, replaces the comment (surrounding whitespace is
   * trimmed); empty clears it. Absent leaves the comment unchanged. At most
   * 2000 characters.
   *
   * @generated from field: optional string comment = 4;
   */
  comment?: string | undefined;
};

/**
 * @generated from message creativefabrica.studioagent.v1.SetGenerationFeedbackRequest
 */
export type SetGenerationFeedbackRequestJson = {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId?: string;

  /**
   * generation_id is the genai generation id — the
   * creativefabrica.modality.v1.Generation.generation_id a MEDIA message
   * carries in Message.generation.
   *
   * @generated from field: string generation_id = 2;
   */
  generationId?: string;

  /**
   * rating, when present, replaces the rating; FEEDBACK_RATING_UNSPECIFIED
   * clears it. Absent leaves the rating unchanged.
   *
   * @generated from field: optional creativefabrica.feedback.v1.FeedbackRating rating = 3;
   */
  rating?: FeedbackRatingJson;

  /**
   * comment, when present, replaces the comment (surrounding whitespace is
   * trimmed); empty clears it. Absent leaves the comment unchanged. At most
   * 2000 characters.
   *
   * @generated from field: optional string comment = 4;
   */
  comment?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.SetGenerationFeedbackRequest.
 * Use `create(SetGenerationFeedbackRequestSchema)` to create a new message.
 */
export const SetGenerationFeedbackRequestSchema: GenMessage<SetGenerationFeedbackRequest, {jsonType: SetGenerationFeedbackRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 38);

/**
 * @generated from message creativefabrica.studioagent.v1.SetGenerationFeedbackResponse
 */
export type SetGenerationFeedbackResponse = Message<"creativefabrica.studioagent.v1.SetGenerationFeedbackResponse"> & {
  /**
   * feedback is the caller's feedback on the generation after the update,
   * with target_type FEEDBACK_TARGET_TYPE_GENERATION and target_id the
   * generation_id.
   *
   * @generated from field: creativefabrica.feedback.v1.Feedback feedback = 1;
   */
  feedback?: Feedback | undefined;
};

/**
 * @generated from message creativefabrica.studioagent.v1.SetGenerationFeedbackResponse
 */
export type SetGenerationFeedbackResponseJson = {
  /**
   * feedback is the caller's feedback on the generation after the update,
   * with target_type FEEDBACK_TARGET_TYPE_GENERATION and target_id the
   * generation_id.
   *
   * @generated from field: creativefabrica.feedback.v1.Feedback feedback = 1;
   */
  feedback?: FeedbackJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.SetGenerationFeedbackResponse.
 * Use `create(SetGenerationFeedbackResponseSchema)` to create a new message.
 */
export const SetGenerationFeedbackResponseSchema: GenMessage<SetGenerationFeedbackResponse, {jsonType: SetGenerationFeedbackResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 39);

/**
 * GenerationModelEntry wraps one genai catalog entry. Agent-specific facts
 * about a model are added here, beside the catalog, never inside it.
 *
 * @generated from message creativefabrica.studioagent.v1.GenerationModelEntry
 */
export type GenerationModelEntry = Message<"creativefabrica.studioagent.v1.GenerationModelEntry"> & {
  /**
   * catalog is genai's entry for the model, untouched: display name and icon,
   * capabilities.input_options with each option's type, allowed values, range
   * and default, input_role_constraints, input_constraint_rules,
   * default_coin_config, pricing_inputs and max_prompt_length.
   * catalog.capabilities.model is the id GenerationPlan.model and
   * ModelChoice.model use.
   *
   * @generated from field: creativefabrica.preset.v1.CatalogModel catalog = 1;
   */
  catalog?: CatalogModel | undefined;
};

/**
 * GenerationModelEntry wraps one genai catalog entry. Agent-specific facts
 * about a model are added here, beside the catalog, never inside it.
 *
 * @generated from message creativefabrica.studioagent.v1.GenerationModelEntry
 */
export type GenerationModelEntryJson = {
  /**
   * catalog is genai's entry for the model, untouched: display name and icon,
   * capabilities.input_options with each option's type, allowed values, range
   * and default, input_role_constraints, input_constraint_rules,
   * default_coin_config, pricing_inputs and max_prompt_length.
   * catalog.capabilities.model is the id GenerationPlan.model and
   * ModelChoice.model use.
   *
   * @generated from field: creativefabrica.preset.v1.CatalogModel catalog = 1;
   */
  catalog?: CatalogModelJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.GenerationModelEntry.
 * Use `create(GenerationModelEntrySchema)` to create a new message.
 */
export const GenerationModelEntrySchema: GenMessage<GenerationModelEntry, {jsonType: GenerationModelEntryJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 40);

/**
 * @generated from message creativefabrica.studioagent.v1.GetCharacterSoulReadinessRequest
 */
export type GetCharacterSoulReadinessRequest = Message<"creativefabrica.studioagent.v1.GetCharacterSoulReadinessRequest"> & {
  /**
   * @generated from field: string character_id = 1;
   */
  characterId: string;
};

/**
 * @generated from message creativefabrica.studioagent.v1.GetCharacterSoulReadinessRequest
 */
export type GetCharacterSoulReadinessRequestJson = {
  /**
   * @generated from field: string character_id = 1;
   */
  characterId?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.GetCharacterSoulReadinessRequest.
 * Use `create(GetCharacterSoulReadinessRequestSchema)` to create a new message.
 */
export const GetCharacterSoulReadinessRequestSchema: GenMessage<GetCharacterSoulReadinessRequest, {jsonType: GetCharacterSoulReadinessRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 41);

/**
 * @generated from message creativefabrica.studioagent.v1.GetCharacterSoulReadinessResponse
 */
export type GetCharacterSoulReadinessResponse = Message<"creativefabrica.studioagent.v1.GetCharacterSoulReadinessResponse"> & {
  /**
   * ready is true when the character has a fully ingested soul.
   *
   * @generated from field: bool ready = 1;
   */
  ready: boolean;

  /**
   * version of the ready soul; 0 when ready is false.
   *
   * @generated from field: int32 version = 2;
   */
  version: number;

  /**
   * ingested_at is when that soul version finished ingesting; unset when
   * ready is false.
   *
   * @generated from field: google.protobuf.Timestamp ingested_at = 3;
   */
  ingestedAt?: Timestamp | undefined;
};

/**
 * @generated from message creativefabrica.studioagent.v1.GetCharacterSoulReadinessResponse
 */
export type GetCharacterSoulReadinessResponseJson = {
  /**
   * ready is true when the character has a fully ingested soul.
   *
   * @generated from field: bool ready = 1;
   */
  ready?: boolean;

  /**
   * version of the ready soul; 0 when ready is false.
   *
   * @generated from field: int32 version = 2;
   */
  version?: number;

  /**
   * ingested_at is when that soul version finished ingesting; unset when
   * ready is false.
   *
   * @generated from field: google.protobuf.Timestamp ingested_at = 3;
   */
  ingestedAt?: TimestampJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.GetCharacterSoulReadinessResponse.
 * Use `create(GetCharacterSoulReadinessResponseSchema)` to create a new message.
 */
export const GetCharacterSoulReadinessResponseSchema: GenMessage<GetCharacterSoulReadinessResponse, {jsonType: GetCharacterSoulReadinessResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 42);

/**
 * @generated from message creativefabrica.studioagent.v1.BatchGetCharacterSoulReadinessRequest
 */
export type BatchGetCharacterSoulReadinessRequest = Message<"creativefabrica.studioagent.v1.BatchGetCharacterSoulReadinessRequest"> & {
  /**
   * character_ids to look up; duplicates are collapsed.
   *
   * @generated from field: repeated string character_ids = 1;
   */
  characterIds: string[];
};

/**
 * @generated from message creativefabrica.studioagent.v1.BatchGetCharacterSoulReadinessRequest
 */
export type BatchGetCharacterSoulReadinessRequestJson = {
  /**
   * character_ids to look up; duplicates are collapsed.
   *
   * @generated from field: repeated string character_ids = 1;
   */
  characterIds?: string[];
};

/**
 * Describes the message creativefabrica.studioagent.v1.BatchGetCharacterSoulReadinessRequest.
 * Use `create(BatchGetCharacterSoulReadinessRequestSchema)` to create a new message.
 */
export const BatchGetCharacterSoulReadinessRequestSchema: GenMessage<BatchGetCharacterSoulReadinessRequest, {jsonType: BatchGetCharacterSoulReadinessRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 43);

/**
 * @generated from message creativefabrica.studioagent.v1.BatchGetCharacterSoulReadinessResponse
 */
export type BatchGetCharacterSoulReadinessResponse = Message<"creativefabrica.studioagent.v1.BatchGetCharacterSoulReadinessResponse"> & {
  /**
   * readiness holds one entry per requested character id, in no guaranteed
   * order. Ids without an ingested soul are present with ready=false.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.CharacterSoulReadiness readiness = 1;
   */
  readiness: CharacterSoulReadiness[];
};

/**
 * @generated from message creativefabrica.studioagent.v1.BatchGetCharacterSoulReadinessResponse
 */
export type BatchGetCharacterSoulReadinessResponseJson = {
  /**
   * readiness holds one entry per requested character id, in no guaranteed
   * order. Ids without an ingested soul are present with ready=false.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.CharacterSoulReadiness readiness = 1;
   */
  readiness?: CharacterSoulReadinessJson[];
};

/**
 * Describes the message creativefabrica.studioagent.v1.BatchGetCharacterSoulReadinessResponse.
 * Use `create(BatchGetCharacterSoulReadinessResponseSchema)` to create a new message.
 */
export const BatchGetCharacterSoulReadinessResponseSchema: GenMessage<BatchGetCharacterSoulReadinessResponse, {jsonType: BatchGetCharacterSoulReadinessResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 44);

/**
 * CharacterSoulReadiness is one character's soul-readiness view.
 *
 * @generated from message creativefabrica.studioagent.v1.CharacterSoulReadiness
 */
export type CharacterSoulReadiness = Message<"creativefabrica.studioagent.v1.CharacterSoulReadiness"> & {
  /**
   * @generated from field: string character_id = 1;
   */
  characterId: string;

  /**
   * ready is true when the character has a fully ingested soul.
   *
   * @generated from field: bool ready = 2;
   */
  ready: boolean;

  /**
   * version of the ready soul; 0 when ready is false.
   *
   * @generated from field: int32 version = 3;
   */
  version: number;

  /**
   * ingested_at is when that soul version finished ingesting; unset when
   * ready is false.
   *
   * @generated from field: google.protobuf.Timestamp ingested_at = 4;
   */
  ingestedAt?: Timestamp | undefined;
};

/**
 * CharacterSoulReadiness is one character's soul-readiness view.
 *
 * @generated from message creativefabrica.studioagent.v1.CharacterSoulReadiness
 */
export type CharacterSoulReadinessJson = {
  /**
   * @generated from field: string character_id = 1;
   */
  characterId?: string;

  /**
   * ready is true when the character has a fully ingested soul.
   *
   * @generated from field: bool ready = 2;
   */
  ready?: boolean;

  /**
   * version of the ready soul; 0 when ready is false.
   *
   * @generated from field: int32 version = 3;
   */
  version?: number;

  /**
   * ingested_at is when that soul version finished ingesting; unset when
   * ready is false.
   *
   * @generated from field: google.protobuf.Timestamp ingested_at = 4;
   */
  ingestedAt?: TimestampJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.CharacterSoulReadiness.
 * Use `create(CharacterSoulReadinessSchema)` to create a new message.
 */
export const CharacterSoulReadinessSchema: GenMessage<CharacterSoulReadiness, {jsonType: CharacterSoulReadinessJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_service, 45);

/**
 * @generated from enum creativefabrica.studioagent.v1.ResolveMessageActionDecision
 */
export enum ResolveMessageActionDecision {
  /**
   * @generated from enum value: RESOLVE_MESSAGE_ACTION_DECISION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESOLVE_MESSAGE_ACTION_DECISION_APPROVE = 1;
   */
  APPROVE = 1,

  /**
   * @generated from enum value: RESOLVE_MESSAGE_ACTION_DECISION_REJECT = 2;
   */
  REJECT = 2,
}

/**
 * @generated from enum creativefabrica.studioagent.v1.ResolveMessageActionDecision
 */
export type ResolveMessageActionDecisionJson = "RESOLVE_MESSAGE_ACTION_DECISION_UNSPECIFIED" | "RESOLVE_MESSAGE_ACTION_DECISION_APPROVE" | "RESOLVE_MESSAGE_ACTION_DECISION_REJECT";

/**
 * Describes the enum creativefabrica.studioagent.v1.ResolveMessageActionDecision.
 */
export const ResolveMessageActionDecisionSchema: GenEnum<ResolveMessageActionDecision, ResolveMessageActionDecisionJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_service, 0);

/**
 * StudioAgentService is the user-authenticated chat API. The caller identity is
 * read from the request context (auth.UserID); request messages carry no
 * user_id.
 *
 * @generated from service creativefabrica.studioagent.v1.StudioAgentService
 */
export const StudioAgentService: GenService<{
  /**
   * ListAgents returns the configured agent types.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ListAgents
   */
  listAgents: {
    methodKind: "unary";
    input: typeof ListAgentsRequestSchema;
    output: typeof ListAgentsResponseSchema;
  },
  /**
   * CreateConversation starts a conversation bound to a character.
   *
   * For an agent with Agent.requires_subscription it fails with
   * FAILED_PRECONDITION when the caller has no active Studio AI subscription;
   * the error carries a creativefabrica.errors.v1.Error detail of type COIN
   * with code COIN_ERROR_CODE_MISSING_AI_STUDIO_SUBSCRIPTION. The check runs
   * once, here: conversations that already exist stay usable.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.CreateConversation
   */
  createConversation: {
    methodKind: "unary";
    input: typeof CreateConversationRequestSchema;
    output: typeof CreateConversationResponseSchema;
  },
  /**
   * ListConversations returns the caller's conversations, most-recent first.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ListConversations
   */
  listConversations: {
    methodKind: "unary";
    input: typeof ListConversationsRequestSchema;
    output: typeof ListConversationsResponseSchema;
  },
  /**
   * GetConversation returns a conversation with its messages.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.GetConversation
   */
  getConversation: {
    methodKind: "unary";
    input: typeof GetConversationRequestSchema;
    output: typeof GetConversationResponseSchema;
  },
  /**
   * ListMessages pages BACKWARDS through a conversation's history for infinite
   * scroll: each page returns the most recent messages before the cursor,
   * newest-first within the page. GetConversation serves the initial recent
   * window; the cursor from each ListMessages page loads the one before it.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ListMessages
   */
  listMessages: {
    methodKind: "unary";
    input: typeof ListMessagesRequestSchema;
    output: typeof ListMessagesResponseSchema;
  },
  /**
   * RenameConversation sets a custom title.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.RenameConversation
   */
  renameConversation: {
    methodKind: "unary";
    input: typeof RenameConversationRequestSchema;
    output: typeof RenameConversationResponseSchema;
  },
  /**
   * DeleteConversation soft-deletes a conversation.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.DeleteConversation
   */
  deleteConversation: {
    methodKind: "unary";
    input: typeof DeleteConversationRequestSchema;
    output: typeof DeleteConversationResponseSchema;
  },
  /**
   * EstimateTurn returns the coin cost of the next turn and the caller balance.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.EstimateTurn
   */
  estimateTurn: {
    methodKind: "unary";
    input: typeof EstimateTurnRequestSchema;
    output: typeof EstimateTurnResponseSchema;
  },
  /**
   * SendMessage posts a user message and returns an ack; the assistant reply is
   * delivered asynchronously over notifications SSE.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.SendMessage
   */
  sendMessage: {
    methodKind: "unary";
    input: typeof SendMessageRequestSchema;
    output: typeof SendMessageResponseSchema;
  },
  /**
   * PrepareConversationUploads registers reusable conversation inputs and
   * returns short-lived HTTP upload forms. It is available only when the
   * conversation's configured agent accepts USER_UPLOAD inputs.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.PrepareConversationUploads
   */
  prepareConversationUploads: {
    methodKind: "unary";
    input: typeof PrepareConversationUploadsRequestSchema;
    output: typeof PrepareConversationUploadsResponseSchema;
  },
  /**
   * RegisterExternalAsset turns a media object another Creative Fabrica
   * product produced (video generator, video editor, flow, …) into a reusable
   * conversation input without a second upload or a coin charge: the object
   * is copied into the agent's private store, probed, and named with the next
   * {{image_N}} / {{video_N}} / {{audio_N}} token with source
   * GENERATED_OUTPUT, so the next turn can mention it. Only objects in the
   * configured Creative Fabrica buckets are accepted; registering the same
   * object again returns the existing token. It is available only when the
   * conversation's configured agent accepts GENERATED_OUTPUT inputs of the
   * object's media type.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.RegisterExternalAsset
   */
  registerExternalAsset: {
    methodKind: "unary";
    input: typeof RegisterExternalAssetRequestSchema;
    output: typeof RegisterExternalAssetResponseSchema;
  },
  /**
   * ImportWebMedia adds media from a public http(s) URL outside Creative
   * Fabrica to the conversation as a reusable {{upload_N}} input with source
   * WEB_IMPORT. It returns at once with the ref PENDING (stage QUEUED); the
   * server then downloads, verifies and stores the file, reporting progress
   * and the outcome through InputRefUpdated notifications and
   * BatchGetInputRefs. Only direct image and video files are accepted; web
   * pages and streams fail with WEB_IMPORT_FAILURE_PAGE_OR_STREAM. Importing
   * a URL the conversation already holds (pending or ready) returns that ref,
   * and repeating a request with the same client_file_id returns the same
   * ref. Available only when the conversation's agent accepts WEB_IMPORT
   * inputs.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ImportWebMedia
   */
  importWebMedia: {
    methodKind: "unary";
    input: typeof ImportWebMediaRequestSchema;
    output: typeof ImportWebMediaResponseSchema;
  },
  /**
   * ResolveMessageAction approves or rejects a pending assistant action.
   * Repeating the same decision is idempotent; the opposite decision fails
   * with FAILED_PRECONDITION.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ResolveMessageAction
   */
  resolveMessageAction: {
    methodKind: "unary";
    input: typeof ResolveMessageActionRequestSchema;
    output: typeof ResolveMessageActionResponseSchema;
  },
  /**
   * GenerateCharacterMedia proposes an image or video of the conversation's
   * character (character-bound agents only). It returns a completed assistant
   * action message id; generation does not begin until ResolveMessageAction
   * approves it.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.GenerateCharacterMedia
   */
  generateCharacterMedia: {
    methodKind: "unary";
    input: typeof GenerateCharacterMediaRequestSchema;
    output: typeof GenerateCharacterMediaResponseSchema;
  },
  /**
   * GetCharacterSoulReadiness reports whether a character has an ingested,
   * usable soul — the gate a client checks before offering chat for the
   * character. ready is true only when a soul version has fully ingested
   * (ingest_status = ready).
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.GetCharacterSoulReadiness
   */
  getCharacterSoulReadiness: {
    methodKind: "unary";
    input: typeof GetCharacterSoulReadinessRequestSchema;
    output: typeof GetCharacterSoulReadinessResponseSchema;
  },
  /**
   * BatchGetCharacterSoulReadiness reports soul readiness for many characters
   * in one call — for roster views that badge every character at once. A
   * character with no ingested soul (or an unknown id) is returned with
   * ready=false rather than an error.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.BatchGetCharacterSoulReadiness
   */
  batchGetCharacterSoulReadiness: {
    methodKind: "unary";
    input: typeof BatchGetCharacterSoulReadinessRequestSchema;
    output: typeof BatchGetCharacterSoulReadinessResponseSchema;
  },
  /**
   * ListConversationRefs lists a conversation's reusable upload and generated
   * media registry without fetching the whole conversation — for asset-token
   * pickers ({{upload_N}} / {{image_N}}) and media panels. The legacy
   * generated-output refs remain alongside the product-safe input_refs during
   * migration.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ListConversationRefs
   */
  listConversationRefs: {
    methodKind: "unary";
    input: typeof ListConversationRefsRequestSchema;
    output: typeof ListConversationRefsResponseSchema;
  },
  /**
   * BatchGetInputRefs returns the current state of specific conversation
   * inputs, for example to refresh pending web imports when a notification
   * was missed. It works for every input ref kind (uploads, web imports,
   * registered assets). Unknown refs are omitted.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.BatchGetInputRefs
   */
  batchGetInputRefs: {
    methodKind: "unary";
    input: typeof BatchGetInputRefsRequestSchema;
    output: typeof BatchGetInputRefsResponseSchema;
  },
  /**
   * ListGenerationModels returns the generation models a conversation's agent
   * offers, each as genai's own catalog entry — the same
   * creativefabrica.preset.v1.CatalogModel that media-matrix, Flow and
   * Workflows list — so a client builds a model's settings controls, applies
   * its constraint rules and quotes its price exactly as it does for those
   * products. It is the companion of MediaGenerationApproval.model_choices:
   * the card names the models, this call describes them. The catalog view is
   * the conversation's (agent, surface, content mode); the response does not
   * depend on any card, so clients may cache it per conversation and model id.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ListGenerationModels
   */
  listGenerationModels: {
    methodKind: "unary";
    input: typeof ListGenerationModelsRequestSchema;
    output: typeof ListGenerationModelsResponseSchema;
  },
  /**
   * SetGenerationFeedback creates or updates the caller's feedback on a
   * completed generation of the conversation: a like / dislike and an
   * optional comment, each changeable later. Only the fields present in the
   * request change, so a comment can follow a rating in a separate call.
   * Repeating a call is idempotent.
   *
   * It fails with NOT_FOUND when the conversation or the generation (within
   * that conversation) does not exist, FAILED_PRECONDITION when the
   * generation has not completed, and INVALID_ARGUMENT when neither rating
   * nor comment is present or the comment is longer than 2000 characters.
   *
   * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.SetGenerationFeedback
   */
  setGenerationFeedback: {
    methodKind: "unary";
    input: typeof SetGenerationFeedbackRequestSchema;
    output: typeof SetGenerationFeedbackResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_studioagent_v1_service, 0);

